import { action, computed, observable, makeObservable } from 'mobx';
import {findFirstLiveTrack, XMediaStreamState} from '../models';
import {MediaStreamTrackStateStore} from './MediaStreamTrackStateStore';

export class MediaStreamStateStore {
  @observable.ref
  audio: MediaStreamTrackStateStore | null = null;

  @observable.ref
  video: MediaStreamTrackStateStore | null = null;

  constructor(readonly stream: MediaStream) {
    makeObservable(this);
    this.updateState();
    stream.onaddtrack = this.updateState;
    stream.onremovetrack = this.updateState;
  }

  @action
  public updateState = () => {
    const audioTrack = findFirstLiveTrack(this.stream.getAudioTracks());
    if (audioTrack === null) {
      this.audio?.dispose();
      this.audio = null;
    }
    else if (this.audio === null)
      this.audio = new MediaStreamTrackStateStore(audioTrack);
    else if (this.audio.track.id !== audioTrack.id) {
      this.audio.dispose();
      this.audio = new MediaStreamTrackStateStore(audioTrack);
    }

    const videoTrack = findFirstLiveTrack(this.stream.getVideoTracks());
    if (videoTrack === null) {
      this.video?.dispose();
      this.video = null;
    }
    else if (this.video === null)
      this.video = new MediaStreamTrackStateStore(videoTrack);
    else if (this.video.track.id !== videoTrack.id) {
      this.video.dispose();
      this.video = new MediaStreamTrackStateStore(videoTrack);
    }
  };

  @computed
  get state(): XMediaStreamState {
    return {
      audio: this.audio !== null ? this.audio.state : null,
      video: this.video !== null ? this.video.state : null
    };
  }

  dispose = () => {
    this.stream.onaddtrack = null;
    this.stream.onremovetrack = null;
    this.audio?.dispose();
    this.audio = null;
    this.video?.dispose();
    this.video = null;
  };
}
